import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from '@/lib/auth/context';
import { initTheme } from '@/lib/theme';
import { routeTree } from './routeTree.gen';
import { registerServiceWorker } from './sw/register.ts';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Sumber kebenaran di lapangan adalah IndexedDB; jaringan hanya untuk sinkronisasi.
      networkMode: 'offlineFirst',
      staleTime: Number.POSITIVE_INFINITY,
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById('root');
if (!container) throw new Error('Elemen #root tidak ditemukan');

// Tema diterapkan sebelum render pertama supaya tidak ada kedipan terang-gelap.
initTheme();

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);

registerServiceWorker();
